import { Link, useParams, useLocation, useSearchParams } from "react-router-dom";
import "./RecoverPass.css";
import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, Slide, Stack } from "@mui/material";
//import { IconVisibility, IconVisibilityOff } from "@aws-amplify/ui-react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CircularProgress from '@mui/material/CircularProgress';
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Amplify } from 'aws-amplify';
import { confirmResetPassword } from 'aws-amplify/auth';
import { validarCambioPassword } from "global/util/validators";
import { TransitionProps } from '@mui/material/transitions';

import awsconfig from 'aws-config';
//Amplify.configure(awsconfig);

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement<any, any>;
	},
	ref: React.Ref<unknown>,
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export const RecoverPassStep2 = () => {

	const [codigo, setCodigo] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};
	const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
	const handleClickShowPasswordConfirm = () => setShowPasswordConfirm((show) => !show);
	const handleMouseDownPasswordConfirm = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};
	const [loginError, setLoginError] = useState('');
	const [loading, setLoading] = useState(false);
	const [searchParams] = useSearchParams();
	const user = searchParams.get('user')
	const [showErrors, setShowErrors] = useState<any>({ state: true, errors: [] });
	const [open, setOpen] = useState(false);

	const handleCodigoChange = (codigo: string) => {

		setCodigo(codigo);
	};
	const handleCloseModal = () => {
		setOpen(false);
	};

	const handlePasswordRecovery = async () => {
		setLoading(true);
		try {
			const passwordOld = "";
			setShowErrors(validarCambioPassword({ passwordOld, password, confirmPassword }));
			if (!showErrors.state) {
				setLoginError('');
				return;
			}
			const data = await confirmResetPassword({ username: user ? user : "", confirmationCode: codigo, newPassword: password });
			setLoginError('');
			setOpen(true);
		} catch (error) {
			setLoginError(processForgotPasswordError(error));
		} finally {
			setLoading(false);
		}

	};

	const processForgotPasswordError = (error: any): string => {
		switch (error.code) {
			case 'CodeMismatchException':
				return 'El código de confirmación proporcionado no es válido.';
			case 'ExpiredCodeException':
				return 'El código de confirmación ha expirado. Por favor, solicita uno nuevo.';
			case 'InvalidPasswordException':
				return 'La nueva contraseña proporcionada no cumple con la política de contraseñas.';
			default:
				return 'Ha ocurrido un error inesperado. Por favor, intenta nuevamente.';
		}
	};

	return (
		<Box
			className="home-component"
			sx={{ width: 400, marginTop: 3, marginBottom: 5 }}
		>
			<div className="password-recovery-container">
				<h2>Recuperar contraseña</h2>
				Ingresa el c&oacute;digo que fue enviado a tu correo electr&oacute;nico y luego ingresa tu nueva contraseña.
				<TextField fullWidth sx={{ mt: 1, mb: 1 }} 
					id="outlined-basic" 
					label="Código de Recuperación" 
					type="text" 
					value={codigo} 
					onChange={(e) => handleCodigoChange(e.target.value)} 
					autoComplete="off"
					/>
				<FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
					<label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-colorPrimary MuiFormLabel-filled MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined css-1jy569b-MuiFormLabel-root-MuiInputLabel-root" >
						La contraseña nueva debe contener números, caracteres especiales, mayúsculas y minúsculas
					</label>
				</FormControl>
				<FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
					<label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-colorPrimary MuiFormLabel-filled MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined css-1jy569b-MuiFormLabel-root-MuiInputLabel-root" >
					</label>
				</FormControl>
				<FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
					<InputLabel htmlFor="outlined-adornment-password">Contraseña nueva</InputLabel>
					<OutlinedInput
						id="outlined-adornment-password"
						type={showPassword ? 'text' : 'password'}
						autoComplete="new-password"
						inputProps={{ form: { autoComplete: 'off' } }}
						endAdornment={
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
									onMouseDown={handleMouseDownPassword}
									edge="end"
								>
									{showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
								</IconButton>
							</InputAdornment>
						}
						label="Contraseña nueva"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
				</FormControl>
				<FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
					<InputLabel htmlFor="outlined-adornment-password2">Confirmar contraseña nueva</InputLabel>
					<OutlinedInput
						id="outlined-adornment-password2"
						type={showPasswordConfirm ? 'text' : 'password'}
						autoComplete="new-password"
						inputProps={{ form: { autoComplete: 'off' } }}
						endAdornment={
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPasswordConfirm}
									onMouseDown={handleMouseDownPasswordConfirm}
									edge="end"
								>
									{showPasswordConfirm ? <VisibilityOffIcon /> : <VisibilityIcon />}
								</IconButton>
							</InputAdornment>
						}
						label="Confirmar contraseña nueva"
						value={confirmPassword}
						onChange={(e) => setConfirmPassword(e.target.value)}
					/>
				</FormControl>
				{
					!showErrors.state ?
						<>
							{showErrors.errors.map((error: any) => {
								return <p style={{ color: "red" }}>*{error.message}</p>
							})}
						</> :
						<></>
				}
				{
					loginError === '' ?
						<></> :
						<p style={{ color: "red" }}>*{loginError}</p>
				}
				<Stack spacing={1} direction="row" justifyContent="center" marginTop={2}>
					<Button disabled={loading} variant="contained" onClick={handlePasswordRecovery} style={{ backgroundColor: "#FE894A" }}>
						{loading ? <CircularProgress size={24} color="inherit" /> : "Recuperar contraseña"}
					</Button>
				</Stack>
			</div>

			<Dialog
				open={open && showErrors.state}
				TransitionComponent={Transition}
				keepMounted
				onClose={handleCloseModal}
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle>{"Confirmación de restablecimiento de contraseña"}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description">
						Se ha restablecido tu contraseña.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Link to={`/login`} onClick={handleCloseModal}>
						<Button>Aceptar</Button>
					</Link>
				</DialogActions>

			</Dialog>
		</Box>
	);
};
